import { downloadBlob, getApi, getBlob, postApi } from "../../common/actions/net.js";
import { messageType, pushSystemMessage } from "../../common/actions/systemMessage.js";

import { ContentTypes } from "../../common/net/httpClient.js";
import Logger from "../../common/util/Logger.js";
import { getExistingProductImage } from "./productImage.js";
import { getPropertyValue } from "../../common/util/changeUtils.jsx";
import { isAllBagNumberValidated } from "../util/historyUtil";
import { makeApiUrl } from "../../common/util/config.jsx";

export const HISTORY_TYPES = {
    ALL: undefined,
    INVOICES: 1,
    CREDIT_NOTES: 2,
    CLAIMS: 3,
    MONTHLY_REPORTS: 4,
    DELIVERY_NOTES: 6
};

export const EDIT_DOCUMENT_HISTORY_QUERY = "EDIT_DOCUMENT_HISTORY_QUERY";
export const ADD_DOCUMENTS_HISTORY_QUERY_RESULTS = "ADD_DOCUMENTS_HISTORY_QUERY_RESULTS";
export const CLEAR_DOCUMENTS_HISTORY_QUERY_RESULTS = "CLEAR_DOCUMENTS_HISTORY_QUERY_RESULTS";
export const ADD_TOBACCO_BAG = "ADD_TOBACCO_BAG";
export const EDIT_TOBACCO_BAG = "EDIT_TOBACCO_BAG";
export const ADD_ITEM_TO_TOBACCO_BAG = "ADD_ITEM_TO_TOBACCO_BAG";
export const REMOVE_ITEM_FROM_TOBACCO_BAG = "REMOVE_ITEM_FROM_TOBACCO_BAG";
export const EDIT_TOBACCO = "EDIT_TOBACCO";
export const ADD_SAVEDTOBACCO_RETURN_RESULTS = "ADD_SAVEDTOBACCO_RETURN";
export const SET_TOBACCO_UNCONFIRMEDCOMPLAINTID = "SET_TOBACCO_UNCONFIRMEDCOMPLAINTID";
export const CLEAR_SUPPLIER = "CLEAR_SUPPLIER";
export const ADD_INVOICE_ID_TO_LIST = "ADD_INVOICE_ID_TO_LIST";
export const ADD_TO_CLAIM_SALES_UNITS = "ADD_TO_CLAIM_SALES_UNITS";
export const REMOVE_FROM_CLAIM_SALES_UNITS = "REMOVE_FROM_CLAIM_SALES_UNITS";
export const ADD_TO_CLAIM_WAREHOUSE_UNITS = "ADD_TO_CLAIM_WAREHOUSE_UNITS";
export const REMOVE_FROM_CLAIM_WAREHOUSE_UNITS = "REMOVE_FROM_CLAIM_WAREHOUSE_UNITS";
export const EDIT_CLAIM = "EDIT_CLAIM";
export const EDIT_CLAIM_ITEM = "EDIT_CLAIM_ITEM";
export const CLEAR_CLAIM = "CLEAR_CLAIM";
export const SET_INVOICE_DETAILS = "SET_INVOICE_DETAILS";


/**
 * Ändra i filter för dokumentquery
 * @param {object} filter - Nytt filter till dokumentquery
 * @returns {func}
 */
export function editDocumentHistoryQuery(filter) {
    return async (dispatch, getState) => {
        dispatch({
            type: EDIT_DOCUMENT_HISTORY_QUERY,
            change: {
                filter,
                loading: true
            }
        });

        let allResultsLoaded = false;

        try {
            const state = getState();
            const newFilter = state.history.documents.filter;

            dispatch(clearDocumentsHistoryQueryResults());

            let freeText = newFilter.searchString;
            if (freeText) {
                freeText.trim();

                if (freeText.length === 0) {
                    freeText = undefined;
                }
            }

            const {payload} = await dispatch(getApi("History/HistoryByFilterQuery", {
                CustomerId: state.authentication.signedInAs,
                HistoryType: newFilter.historyType,
                NoOfHistories: 25,
                StartIndex: 0,
                FreeText: freeText
            }));

            dispatch({
                type: ADD_DOCUMENTS_HISTORY_QUERY_RESULTS,
                results: payload
            });

            allResultsLoaded = payload.length < 25;
        } finally {
            dispatch({
                type: EDIT_DOCUMENT_HISTORY_QUERY,
                change: {
                    filter: {},
                    loading: false,
                    allResultsLoaded
                }
            });
        }
    };
}

/**
 * Rensa resultaten för dokumentquery
 * @returns {object}
 */
export function clearDocumentsHistoryQueryResults() {
    return {
        type: CLEAR_DOCUMENTS_HISTORY_QUERY_RESULTS
    };
}

/**
 * Ladda fler resultat i dokumentquery
 * @returns {func}
 */
export function loadMoreDocumentsHistoryQueryResults() {
    return async (dispatch, getState) => {
        const state = getState();

        if (state.history.documents.allResultsLoaded) {
            return;
        }

        const filter = state.history.documents.filter;

        let freeText = filter.searchString;
        if (freeText) {
            freeText.trim();

            if (freeText.length === 0) {
                freeText = undefined;
            }
        }

        dispatch({
            type: EDIT_DOCUMENT_HISTORY_QUERY,
            change: {
                loading: true
            }
        });

        let allResultsLoaded = false;

        try {
            const {payload} = await dispatch(getApi("History/HistoryByFilterQuery", {
                CustomerId: state.authentication.signedInAs,
                HistoryType: filter.historyType,
                NoOfHistories: 25,
                StartIndex: state.history.documents.results.length,
                FreeText: freeText
            }));

            dispatch({
                type: ADD_DOCUMENTS_HISTORY_QUERY_RESULTS,
                results: payload
            });

            allResultsLoaded = payload.length < 25;
        } finally {
            dispatch({
                type: EDIT_DOCUMENT_HISTORY_QUERY,
                change: {
                    loading: false,
                    allResultsLoaded
                }
            }); 
        }
    };
}

/**
 * Validates entered bagno
 * @param {string} supplierId
 * @param {number} bagIndex
 * @returns {func}
 */
export function validateBagNumber(supplierId, bagIndex){
    return async (dispatch, getState) => {
        try {
            const {
                history : {
                    tobacco,
                }
            } = getState();

            const supplierIndex = tobacco.bagSupplier.findIndex( (ele) => ele.supplierId === supplierId );
            if( supplierIndex<0 ){
                throw "Supplier index failed";
            }
            const bagNumber = getPropertyValue(tobacco,["bagSupplier",supplierIndex,"bags",bagIndex,"bagNumber"]);
            if( !bagNumber ){
                throw "Getting bag number failed";
            }

            const {payload} = await dispatch( postApi("Return/CreateTobaccoReturnBag",{
                supplierId: supplierId,
                bagNumber: bagNumber,
            }) );

            if(payload.createdReturnBagNo > 0){
                await dispatch({
                    type: EDIT_TOBACCO_BAG,
                    supplierId,
                    bagIndex,
                    change: {
                        bagNumber: payload.createdReturnBagNo,
                        bagNumberValidated: true,
                    },
                });
            } else {
                dispatch( pushSystemMessage(payload.errorMessage, messageType.error) );
            }

        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * adds a tobacco bag
 * @param {object} product 
 * @returns {func}
 */
export function addTobaccoBag(product){
    return async (dispatch) => {
        try {
            //if no printed bag number, then we have to ask the api for one
            if( product.preprintedBagNo===false ){
                const {message, payload} = await dispatch( postApi("Return/CreateTobaccoReturnBag",{
                    supplierId: product.supplierId,
                    productId: product.productId,
                    bagNumber: "",
                }) );
                if( message==="OK"){
                    await dispatch({
                        type: ADD_TOBACCO_BAG,
                        supplierName: product.supplierName,
                        supplierId: product.supplierId,
                        bagNumber: payload.createdReturnBagNo,
                        bagNumberValidated: true,
                        bagNumberEditable: false,
                    });
                } else {
                    throw "Creating bag failed";
                }
            } else {
                await dispatch({
                    type: ADD_TOBACCO_BAG,
                    supplierName: product.supplierName,
                    supplierId: product.supplierId,
                    bagNumber: "",
                    bagNumberValidated: false,
                    bagNumberEditable: true,
                });
            }
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Removes a supplier from the tobacco list
 * @param {number} supplierId
 * @returns {func}
 */
export function clearSupplier(supplierId){
    return async (dispatch) => {
        try {
            dispatch({
                type: CLEAR_SUPPLIER,
                change: {
                    supplierId,
                }
            });

        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Clears the tobacco list completly
 * @returns {func}
 */
export function clearAll(){
    return async (dispatch, getState) => {
        try {

            const state = getState();
            
            if(state.history.tobacco.sentToEP)
            {
                // Not possible to delete return if sent to EP, give message
                dispatch(pushSystemMessage("Denne retur har allerede sents till Kolly og kan ikke slettes.", messageType.error) );
                return;
            }

            // Clear the state, all lines and description
            dispatch({
                type: EDIT_TOBACCO,
                change:{
                    bagSupplier: [],
                    description: "",
                }
            });

            // Delete from DB (temp table)
            dispatch(saveTobaccoReturn());

            // Finally, Clear state of ID
            dispatch({
                type: EDIT_TOBACCO,
                change:{
                    unconfirmedComplaintId: null,
                }
            });

        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Adds or remove products in tobacco bags
 * @param {object} product 
 * @param {number} qty
 * @param {number} value
 * @returns {func}
 */
export function addRemoveProductToTobaccoBag(product, qty){
    return async (dispatch, getState) => {
        try {
            const {
                history : {
                    tobacco,
                }
            } = getState();

            if( product.returnTobaccoNotAllowedAnyLonger===true ){
                dispatch( pushSystemMessage(`Leverandøren har sluttet å ta retur på vare '${product.productName}'.`, messageType.error) );
                return;
            }

            //if the supplier is not added then create it and add a bag
            if( tobacco.bagSupplier.findIndex( (ele) => ele.supplierId === product.supplierId ) === -1 ) {
                await dispatch( addTobaccoBag(product) );
            }
            
            await dispatch({
                type: qty>0?ADD_ITEM_TO_TOBACCO_BAG:REMOVE_ITEM_FROM_TOBACCO_BAG,
                product,
                value: qty,
            });

            const supplierIndex = getState().history.tobacco.bagSupplier.findIndex( (ele) => ele.supplierId === product.supplierId );
            if( getState().history.tobacco.bagSupplier[supplierIndex].bags[0].lines.length===0 ) {
                dispatch( clearSupplier(product.supplierId) );
            }

        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Edits a supplier bag
 * @param {string} supplierId
 * @param {number} bagIndex
 * @param {object} change
 * @returns {func}
 */
export function edditSupplierBag(supplierId, bagIndex, change){
    return async (dispatch, getState) => {
        try {
            const {
                history : {
                    tobacco,
                }
            } = getState();

            if( tobacco.bagSupplier.findIndex( (ele) => ele.supplierId === supplierId ) >= 0 ) {
                await dispatch({
                    type: EDIT_TOBACCO_BAG,
                    supplierId,
                    bagIndex,
                    change,
                });
            }

        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Edit the tobacco return
 * @param {object} change
 * @returns {func}
 */
export function editTobacco(change){
    return async (dispatch) => {
        try {
            dispatch({
                type: EDIT_TOBACCO,
                change
            });

        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Downloads tobacco return scheme file
 * @param {string} token
 * @param {string} tobaccoReturnSchemeFileName
 * @returns {func}
 */
function downloadTobaccoSchemePdf(token, tobaccoReturnSchemeFileName) {
    return async (dispatch) => {
        try {
            if( tobaccoReturnSchemeFileName===null ){
                dispatch( pushSystemMessage("Kunne ikke lage PDF", messageType.error) );
            } else {
                const blob = await getBlob(`Return/TobaccoReturnSchemePdfQuery/${tobaccoReturnSchemeFileName}`, {}, token, ContentTypes.JSON, ContentTypes.PDF, false);
                downloadBlob(blob, `${tobaccoReturnSchemeFileName}.pdf`, ContentTypes.PDF);
            }
        } catch(error){
            Logger.error(error);
        }
    };
}

/**
 *Submits the tobacco return
 * @param {string} token
 * @param {function} callbackOnSuccess
 * @returns {func}
 */
export function submitTobaccoReturn(token, callbackOnSuccess){
    return async (dispatch, getState) => {
        try {
            const {
                history : {
                    tobacco,
                }
            } = getState();

            dispatch({
                type: EDIT_TOBACCO,
                change: {
                    submitting: true,
                }
            });

            let lines = [];
            for(let i=0; i<tobacco.bagSupplier.length; i++){
                const supplier = tobacco.bagSupplier[i];
                for(let j=0; j<supplier.bags.length; j++){
                    const bag = supplier.bags[j];
                    lines = lines.concat( bag.lines.map( (ele) => {
                        return {
                            productId: ele.product.productId,
                            wishedQtySalesUnits: ele.wishedQtySalesUnits,
                            supplierId: ele.product.supplierId,
                            supplierReferenceNo: bag.bagNumber,
                        };
                    }));
                }
            }

            // Submit changes - tobacco complaint is created in Epix
            const payload = await dispatch( postApi("Return/CreateTobaccoReturn", {
                description: tobacco.description,
                pickUpByEngrospartner: tobacco.pickUpByEngrospartner,
                unconfirmedComplaintId: tobacco.unconfirmedComplaintId,
                lastSentComplaintId: tobacco.complaintId,
                lines,
            }) );

            if( payload.payload.amountTooLow===false ){
                dispatch({
                    type: SET_TOBACCO_UNCONFIRMEDCOMPLAINTID,
                    unconfirmedComplaintId: payload.payload.unconfirmedComplaintId,
                });

                callbackOnSuccess(payload.payload.message, () => {

                    dispatch( downloadTobaccoSchemePdf(token, payload.payload.tobaccoReturnSchemeFileName) );
                });
                
            } else {
                dispatch( pushSystemMessage(payload.payload.errorMessage, messageType.error) );
            }

        } catch (error) {
            dispatch( pushSystemMessage(error && error.message, messageType.error) );
            Logger.error(error);
        } finally {
            dispatch({
                type: EDIT_TOBACCO,
                change: {
                    submitting: false,
                }
            });
        }
    };
}

/**
 * Get previously stored tobacco return for this customer
 * @returns {func}
 */
export function getSavedTobaccoReturn() {
    return async (dispatch) => {

        dispatch({
            type: EDIT_TOBACCO,
            change: {
                loading: true
            }
        });

        try {
            const {payload} = await dispatch(getApi("Return/SavedTobaccoReturnQuery"));

            // Display result from service
            if(payload != null)
            {
                if(payload.suppliers != null)
                {
                    //insert existing images           
                    for(let i=0; i<payload.suppliers.length; i++){
                        const sup = payload.suppliers[i];
                        for(let j=0; j<sup.bags.length; j++){
                            const bag = sup.bags[j];
                            for(let k=0; k<bag.lines.length; k++){                           
                                payload.suppliers[i].bags[j].lines[k].product.imageUrl = getExistingProductImage(bag.lines[k].productId);
                            } 
                        }    
                    }

                    // Save the found complaint to store
                    dispatch({
                        type: ADD_SAVEDTOBACCO_RETURN_RESULTS,
                        result: payload
                    });
                }               
            }
            if(payload == null || payload.unconfirmedComplaintId == null)
            {
                // Clear the state, all lines and description
                dispatch({
                    type: EDIT_TOBACCO,
                    change:{
                        bagSupplier: [],
                        description: "",
                        unconfirmedComplaintId: null,
                    }
                });
            }
        } finally {
            dispatch({
                type: EDIT_TOBACCO,
                change: {
                    loading: false
                }
            }); 
        }
    };
}

/**
 *Saves the tobacco return (not sent to EP yet)
 * @returns {func}
 * @param {bool} submit
 */
export function saveTobaccoReturn(submit){
    return async (dispatch, getState) => {
        try {
            const {
                history : {
                    tobacco,
                }
            } = getState();

            dispatch({
                type: EDIT_TOBACCO,
                change: {
                    trySubmit: true,
                }
            });

            // first check that all bag numbers are entered correctly    
            const supplierWithFaulty = isAllBagNumberValidated(tobacco);

            if(supplierWithFaulty)
            {
                dispatch(pushSystemMessage(`Posenummer må angis for leverandør ${supplierWithFaulty.supplierName}`, messageType.error));
                return supplierWithFaulty;
            }

            dispatch({
                type: EDIT_TOBACCO,
                change: {
                    submitting: true,
                    trySubmit: false,
                }
            });

            let lines = [];
            for(let i=0; i<tobacco.bagSupplier.length; i++){
                const supplier = tobacco.bagSupplier[i];
                for(let j=0; j<supplier.bags.length; j++){
                    const bag = supplier.bags[j];
                    lines = lines.concat( bag.lines.map( (ele) => {
                        return {
                            productId: ele.product.productId,
                            wishedQtySalesUnits: ele.wishedQtySalesUnits,
                            supplierId: ele.product.supplierId,
                            supplierReferenceNo: bag.bagNumber,
                        };
                    }));
                }
            }

            // Call web api
            const payload = await dispatch( postApi("Return/SaveTobaccoReturn", {
                description: tobacco.description,
                pickUpByEngrospartner: tobacco.pickUpByEngrospartner,
                unconfirmedComplaintId: tobacco.unconfirmedComplaintId,
                lines,
            }) );

            // Display result from service
            if(payload.payload.unconfirmedComplaintId != null)
            {
                // Save the complaint id to store
                dispatch({
                    type: EDIT_TOBACCO,
                    change: { unconfirmedComplaintId : payload.payload.unconfirmedComplaintId }
                });

                if(!submit)
                {
                    dispatch(pushSystemMessage(payload.payload.message, messageType.message));
                }                
            }
            else if (payload.displayMessage != null)
            {
                // Something went wrong
                dispatch(pushSystemMessage(payload.displayMessage, messageType.error));
            }                                   
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message, messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: EDIT_TOBACCO,
                change: {
                    submitting: false,
                }
            });
        }
    };
}


/**
 * adds or remove products from the My List
 * @param {object} product 
 * @param {number} qty
 * @returns {func}
 */
export function addRemoveSalesUnitToClaim(product, qty){
    return async (dispatch) => {
        try {
            if( qty>=0 ){
                //Do change to redux data
                await dispatch({
                    type: ADD_TO_CLAIM_SALES_UNITS,
                    product: product,
                    qty,
                });
            } else {
                //Do change to redux data
                await dispatch({
                    type: REMOVE_FROM_CLAIM_SALES_UNITS,
                    product: product,
                });
            }
            
        } catch (error) {
            Logger.error(error);
        }
    };
}
/**
 * adds or remove products from the My List
 * @param {object} product 
 * @param {number} qty
 * @returns {func}
 */
export function addRemoveWarehouseUnitToClaim(product, qty){
    return async (dispatch) => {
        try {
            if( qty>=0 ){
                //Do change to redux data
                await dispatch({
                    type: ADD_TO_CLAIM_WAREHOUSE_UNITS,
                    product: product,
                    qty,
                });
            } 
            else {
                //Do change to redux data
                await dispatch({
                    type: REMOVE_FROM_CLAIM_WAREHOUSE_UNITS,
                    product: product,
                });
            }
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Edits claim properties
 * @param {number} change
 * @returns {func}
 */
export function editClaim(change){
    return async (dispatch) => {
        try {
            await dispatch({
                type: EDIT_CLAIM,
                change,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Edits claim properties for a list item
 * @param {string} productId
 * @param {number} change
 * @returns {func}
 */
export function editClaimItem(productId, change){
    return async (dispatch) => {
        try {
            await dispatch({
                type: EDIT_CLAIM_ITEM,
                productId,
                change,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Commit invoice claim
 * @param {object} history
 * @param {string} invoiceId
 * @returns {func}
 */
export function commitInvoiceClaim(history, invoiceId){
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: EDIT_CLAIM,
                committing: true,
            });
            const claim = getState().history.claim;

            // Create formdata object, must use uppercase objects, so create a new one...
            const formData = new FormData();

            const lines = claim.lines.map(l  => ({
                ProductId: l.product.productId,
                ClaimQtySalesUnits: l.claimQtySalesUnits,
                ClaimQtyWarehouseUnits: l.claimQtyWarehouseUnits,
                ReasonCode: l.reasonCode,
                ReturnGoods: l.returnGoods ?  l.returnGoods : false,
            }));

            const claimData = {
                InvoiceId : invoiceId,
                Description : claim.description,
                //Attachments : claim.attachments,
                Lines: lines,
            };

            // Attachment array must be treated specially
            claim.attachments.forEach(a => formData.append("Attachments", a));
            
            buildFormData(formData, claimData);            

            const headers = new Headers();
            headers.append("Accept", ContentTypes.JSON);
            headers.append("Authorization", `Bearer ${getState().authentication.token}`);

            const payload = await fetch(makeApiUrl("Return/CreateInvoiceClaim"), {
                method: "POST",
                headers,
                body: formData
            });

            if( payload && payload.ok){
                const mess = await(payload.json());
                dispatch( pushSystemMessage(mess.payload, messageType.message) );
                history.push("/dashboard");
                dispatch({
                    type: CLEAR_CLAIM,
                });
            } else {
                dispatch( pushSystemMessage("Kan ikke opprette reklamasjon", messageType.error) );
            }
        } catch (error) {
            Logger.error(error);
        } finally {
            dispatch({
                type: EDIT_CLAIM,
                committing: false,
            });
        }
    };
}

/**
 * Creates FormData from JS-object
 * @param {object} formData
 * @param {object} data
 * @param {string} parentKey
 * @returns {object}
 */
function buildFormData(formData, data, parentKey) {
    if (data && typeof data === "object" && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } 
    else {
        const value = data == null ? "" : data;
        formData.append(parentKey, value);
    }
}

/**
 * Clears up the claim cart
 * @returns {func}
 */
export function clearClaim(){
    return async (dispatch) => {
        try {
            dispatch({
                type: CLEAR_CLAIM,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Download invoice
 * @param {string} invoiceId
 * @param {string} freeText
 * @returns {func}
 */
export function getInvoiceDetails(invoiceId, freeText){
    return async (dispatch) => {
        try {
            const payload = await dispatch( getApi("History/InvoiceDetailsQuery", { invoiceId: invoiceId, freeText: freeText}) );

            if( payload && payload.payload)
            {
                for(let i=0; i<payload.payload.invoiceLines.length; i++){
                    payload.payload.invoiceLines[i].product.imageUrl = getExistingProductImage(payload.payload.invoiceLines[i].product.productId);
                }

                dispatch({
                    type: SET_INVOICE_DETAILS,
                    invoiceId: invoiceId,
                    invoice: payload.payload,
                });
            }
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Finds the last invoice
 * @param {string} productId 
 * @returns {func}
 */
export function getLastInvoiceForProduct(productId){
    return async (dispatch, getState) => {
        try {
            if( getState().history.lastInvoiceForProduct[productId]===undefined){
                const payload = await dispatch(getApi("Product/LastInvoiceIdForProductQuery", {productId}));
                
                dispatch({
                    type: ADD_INVOICE_ID_TO_LIST,
                    productId,
                    invoiceId: payload.payload,
                });
            }
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Get tobacco supplier
 * @returns {func}
 */
export function getTobaccoSuppliers(){
    return async (dispatch) => {
        try {
            const {payload} = await dispatch(getApi("Product/SupplierNamesQuery"));

            const list = payload.filter( (item) => item.handlesTobacco );

            dispatch({
                type: EDIT_TOBACCO,
                change: {
                    suppliers: list,
                }
            });

        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Downloads a pdf
 * @param {string} token
 * @param {string} signedInAs
 * @param {object} result
 * @returns {func}
 */
export function downloadHistoryPdf(token, signedInAs, result){
    return async (dispatch) => {
        try {
            const blob = await getBlob("History/HistoryPdfFileQuery", {
                customerId: signedInAs,
                historyType: result.historyType,
                historyPdfKey: result.historyPdfKey,
            }, token, ContentTypes.JSON, ContentTypes.PDF, false);
            downloadBlob(blob, `${result.historyType}-${result.historyPdfKey}.pdf`, ContentTypes.PDF);

        } catch (error) {
            dispatch( pushSystemMessage(error.message || "Fil ikke funnet", messageType.error) );
            Logger.error(error);
        }
    };
}

export const EDIT_TOBACCO_DOCUMENTS_HISTORY_QUERY = "EDIT_TOBACCO_DOCUMENTS_HISTORY_QUERY";
export const ADD_TOBACCO_DOCUMENTS_HISTORY_RESULTS = "ADD_TOBACCO_DOCUMENTS_HISTORY_RESULTS";
export const CLEAR_TOBACCO_DOCUMENTS_HISTORY_RESULTS = "CLEAR_TOBACCO_DOCUMENTS_HISTORY_RESULTS";

/**
 * Ändra i filter för tobakshistorik
 * @param {object} filter - Nytt filter till dokumentquery
 * @returns {func}
 */
export function editTobaccoDocumentsHistoryQuery(filter) {
    return async (dispatch, getState) => {
        dispatch({
            type: EDIT_TOBACCO_DOCUMENTS_HISTORY_QUERY,
            change: {
                filter,
                loading: true
            }
        });

        let allResultsLoaded = false;

        try {
            const state = getState();
            const newFilter = state.history.tobaccoDocuments.filter;

            dispatch(clearTobaccoDocumentsHistoryQueryResults());

            let freeText = newFilter.searchString;
            if (freeText) {
                freeText.trim();

                if (freeText.length === 0) {
                    freeText = undefined;
                }
            }

            const {payload} = await dispatch(getApi("Return/ReturnOrdersByFilterQuery", {
                NoOfOrders: 25,
                StartIndex: 0,
                FreeText: freeText
            }));

            dispatch({
                type: ADD_TOBACCO_DOCUMENTS_HISTORY_RESULTS,
                results: payload
            });

            allResultsLoaded = payload.length < 25;
        } finally {
            dispatch({
                type: EDIT_TOBACCO_DOCUMENTS_HISTORY_QUERY,
                change: {
                    filter: {},
                    loading: false,
                    allResultsLoaded
                }
            });
        }
    };
}

/**
 * Rensa resultaten för dokumentquery
 * @returns {object}
 */
export function clearTobaccoDocumentsHistoryQueryResults() {
    return {
        type: CLEAR_TOBACCO_DOCUMENTS_HISTORY_RESULTS
    };
}

/**
 * Ladda fler resultat i dokumentquery
 * @returns {func}
 */
export function loadMoreTobaccoDocumentsHistoryQueryResults() {
    return async (dispatch, getState) => {
        const state = getState();

        if (state.history.tobaccoDocuments.allResultsLoaded) {
            return;
        }

        const filter = state.history.tobaccoDocuments.filter;

        let freeText = filter.searchString;
        if (freeText) {
            freeText.trim();

            if (freeText.length === 0) {
                freeText = undefined;
            }
        }

        dispatch({
            type: EDIT_TOBACCO_DOCUMENTS_HISTORY_QUERY,
            change: {
                loading: true
            }
        });

        let allResultsLoaded = false;

        try {
            const {payload} = await dispatch(getApi("Return/ReturnOrdersByFilterQuery", {
                NoOfOrders: 25,
                StartIndex: state.history.tobaccoDocuments.results.length,
                FreeText: freeText
            }));

            dispatch({
                type: ADD_TOBACCO_DOCUMENTS_HISTORY_RESULTS,
                results: payload
            });

            allResultsLoaded = payload.length < 25;
        } finally {
            dispatch({
                type: EDIT_TOBACCO_DOCUMENTS_HISTORY_QUERY,
                change: {
                    loading: false,
                    allResultsLoaded
                }
            }); 
        }
    };
}